import { render, staticRenderFns } from "./RecordingDetails.vue?vue&type=template&id=047f7ed6&scoped=true&"
import script from "./RecordingDetails.vue?vue&type=script&lang=js&"
export * from "./RecordingDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecordingDetails.vue?vue&type=style&index=0&id=047f7ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047f7ed6",
  null
  
)

export default component.exports